import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../../angular-material.module';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-addd-photo',
  standalone: true,
  imports: [
    AngularMaterialModule,
    CommonModule,
  ],
  templateUrl: './addd-photo.component.html',
  styleUrls: ['./addd-photo.component.scss'],
})
export class AdddPhotoComponent {
  issueId: number;
  baseUrl = environment.baseUrl;
  userId = sessionStorage.getItem('session_id');
  issuePhoto: File | null = null;
  issuePhotoPreview: string | null = null;
  submitting = false;
  isDragOver = false;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AdddPhotoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { issueId: number }
  ) {
    this.issueId = data.issueId;
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  triggerFileInput(input: HTMLInputElement): void {
    input.click();
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.setSelectedFile(file);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const file = event.dataTransfer?.files?.[0];
    if (file && file.type.startsWith('image/')) {
      this.setSelectedFile(file);
    } else {
      this.snackBar.open('Please drop a valid image file.', 'Close', { duration: 3000 });
    }
  }

  deleteFile(): void {
    this.issuePhoto = null;
    this.issuePhotoPreview = null;
  }

  onSubmit(): void {
    if (!this.issuePhoto) {
      this.snackBar.open('Please select an image to upload.', 'Close', { duration: 3000 });
      return;
    }

    const formData = new FormData();
    formData.append('issue_photo', this.issuePhoto);
    formData.append('issue_id', this.issueId.toString());
    formData.append('user_id', this.userId ?? '');
    formData.append('account_id', sessionStorage.getItem('account_id') ?? '');

    this.submitting = true;
    this.http.post(`${this.baseUrl}/upload_image_issue`, formData).subscribe({
      next: (response: any) => {
        this.snackBar.open('Image added successfully!', 'Close', { duration: 3000 });
        this.dialogRef.close({ updated: true, uploadedPhoto: response?.data || response });
      },
      error: () => {
        this.snackBar.open('Error uploading image. Please try again.', 'Close', { duration: 3000 });
      },
      complete: () => {
        this.submitting = false;
      },
    });
  }

  private setSelectedFile(file: File): void {
    this.issuePhoto = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.issuePhotoPreview = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
}
